import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz-trans/client';

import styles from './SpottyCat.module.scss';

const WAITING_TIME = 3000;

const SpottyCatIntro = ({ onNextStep }) => {
  useEffect(() => {
    setTimeout(onNextStep, WAITING_TIME);
  }, [onNextStep]);

  return (
    <div className={styles['spotty-cat__intro']}>
      <div>
        <img
          src="https://d3jv82vfv5das.cloudfront.net/291f7b12d103ca4e863213ff716660cd3be8432f/images/logo-loading.gif"
          alt={trans('spotty-cat-first-screen-text')}
        />
        <p className={styles['spotty-cat__intro-title']}>
          {trans('spotty-cat-first-screen-text')}
        </p>
      </div>
    </div>
  );
};

SpottyCatIntro.propTypes = {
  onNextStep: PropTypes.func.isRequired
};

export default SpottyCatIntro;
